var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vSelect',_vm._g(_vm._b({class:{ ..._vm.customInputClasses },attrs:{"appendToBody":true,"calculatePosition":_vm.calculatePosition,"multiple":_vm.multiple,"options":_vm.generatedOptions,"clearSearchOnSelect":false,"reduce":(item) => item.value,"components":{ Deselect: _vm.Deselect }},scopedSlots:_vm._u([{key:"open-indicator",fn:function({ attributes }){return [_c('iv-icon',_vm._b({staticClass:"mr-1",attrs:{"icon":"fa-solid fa-chevron-down"}},'iv-icon',attributes,false))]}},{key:"no-options",fn:function({ search, searching }){return [_vm._v("\n        "+_vm._s(_vm.$_("w_FormSelectionNoResult"))+"\n    ")]}}])},'vSelect',{
        ..._vm.$attrs,
        ..._vm.$props,
        value: _vm.innateValue,
        label: 'key',
    },false),{
        ..._vm.$listeners,
        input: ($event) => (_vm.innateValue = $event),
    }))
}
var staticRenderFns = []

export { render, staticRenderFns }